import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  GridItem,
} from '@chakra-ui/react';
import React from 'react';
import { useMODataContext } from 'src/features/MO/contexts/MODataContext';
import { OptimizationHeader } from '../../molecules/OptimizationHeader';
import { OptimizationRow } from '../../molecules/OptimizationRow';
import { OptimizationPanel } from '../../organisms/OptimizationPanel';
import { OptimizationContent } from '../../organisms/CreateOptimization';
import { useFilterContext } from 'src/contexts/FilterContext';

type OptimizationsProps = {
  isCreateOptimizationOpen: boolean;
  onClose: () => void;
};

export const Optimizations: React.FC<OptimizationsProps> = ({
  isCreateOptimizationOpen,
  onClose,
}) => {
  const { optimizations } = useMODataContext();
  const { currentModelVersion } = useFilterContext();
  return (
    <GridItem colSpan={14} w="100%" mt={5}>
      {isCreateOptimizationOpen ? (
        <Box maxW={{ base: '100%', md: '85%', lg: '83%' }}>
          <OptimizationContent
            onClose={onClose}
            currentModel={currentModelVersion}
          />
        </Box>
      ) : (
        <>
          <OptimizationHeader />
          <Accordion defaultIndex={[]} allowMultiple>
            {optimizations.data.map((optimization) => {
              return (
                <AccordionItem key={optimization.optimizationId}>
                  {({ isExpanded }) => (
                    <>
                      <h2>
                        <AccordionButton p={0}>
                          <OptimizationRow
                            optimization={optimization}
                            isExpanded={isExpanded}
                          />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4}>
                        <OptimizationPanel
                          optimization={optimization}
                          isOpen={isExpanded}
                        />
                      </AccordionPanel>
                    </>
                  )}
                </AccordionItem>
              );
            })}
          </Accordion>
        </>
      )}
    </GridItem>
  );
};
